<div class="gift-wrapper">
    <div class="container-fluid">
        <div class="justify-content-between align-items-center d-none d-lg-flex">
            <!-- Desktop Layout -->
            <p class="logo-text" routerLink="['/']">{{constants.WINDOW_SWAP_TXT}}</p>
            <app-user-menu [from]="from"></app-user-menu>
        </div>

        <div class="d-flex justify-content-center d-lg-none">
            <!-- Mobile Layout -->
            <p class="logo-text" routerLink="['/']">{{constants.WINDOW_SWAP_TXT}}</p>
        </div>
    </div>
    <div class="text-center d-flex align-items-center justify-content-center flex-column wrapper">
        <div class="row w-100" style="justify-content: center;">
            <div class="col-12 col-lg-5 d-flex justify-content-center align-items-center">
                <img [src]="constants.WS_GIFT_HOME" alt="Gift Window" class="gift-sucess-img mb-4">
            </div>
            <div
                class="col-12 col-lg-5 text-start d-flex justify-content-center align-items-center align-items-lg-start flex-column">
                <p class="heading d-none d-lg-block">{{constants.GIFT_WRAPPED}}</p>
                <p class="heading d-block d-lg-none">{{constants.YOUR_GIFT_IS}}<br>{{constants.BEING_WRAPPED}}</p>
                <p class="description">
                    {{constants.GIFT_TXNS_1}}<br>
                    {{constants.GIFT_TXNS_2}}<br>
                    {{constants.GIFT_TXNS_3}}
                </p>
                <button class="go-home-btn mb-5 mb-lg-0 mt-5 mt-lg-0" routerLink="['/']">
                    <span class="d-none d-lg-block">{{constants.BACK_HOME_LG}}</span>
                    <span class="d-block d-lg-none">{{constants.BACK_HOME_SM}}</span>
                </button>
            </div>
        </div>
        <footer class="footer mt-4 d-none d-lg-flex ">
            <a [href]="constants.INSTAGRAM_LINK" target="_blank" class="footer-link"><img [src]="constants.INS_ICON" /></a>
            <a [routerLink]="['/blog']" target="_blank" class="footer-link"><img [src]="constants.NEW_GIFT_PAYMENT" /></a>
            <a href="https://windowswapblog.squarespace.com/contact" target="_blank" class="footer-link"><img [src]="constants.NEW_CONTACT_PAYMENT" /></a>
            <a [href]="constants.TERMS_CONDITIONS_LINK" class="footer-link"><img [src]="constants.NEW_TERMS_PAYMENT" /></a>
        </footer>
    </div>
</div>